
const changeCodeUseCase = (repository) => async (id, data) => {
    return await repository(id, data);
}

export default changeCodeUseCase;

